import React from "react";

import { Container } from "@material-ui/core";
//import AppBar from '@material-ui/core/AppBar';

import FacebookIcon from "@material-ui/icons/Facebook";
import IconButton from "@material-ui/core/IconButton";

import useStyleFooter from "../styles/useStyleFooter";

import salomoneImage from "../images/soloSalomone.png";

const Footer = () => {
  const classes = useStyleFooter();

  return (
    <>
      {/*<AppBar position="relative" color="secondary" elevation={0} className={classes.appBar}>*/}
      <footer className={classes.appBar}>
        <Container className={classes.footer}>
          <div className={classes.cropper}>
            <img
              src={salomoneImage}
              alt="salomone"
              className={classes.cropperImg}
            />
          </div>
        </Container>
      </footer>
      <footer className={classes.appBar2}>
        <Container className={`${classes.footer} ${classes.footerAlign}`}>
          <IconButton
            aria-label="facebook"
            href="https://www.facebook.com/didaunifi"
          >
            <FacebookIcon />
          </IconButton>
        </Container>
      </footer>
      {/*</AppBar>*/}
    </>
  );
};

export default Footer;
